import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared';
import { AuditLogDialogComponent } from './audit-log.component';
import { AuditLogTableComponent } from './audit-log-table/audit-log-table.component';
import { ContactInformationDialogComponent } from './contact-information-table/contact-information-table.component';
import { ApplicantHistoryDialogComponent } from './applicant-history/applicant-history-dialog.component';
import { RenewalChangesDialogComponent } from './renewal-change-table/renewal-change-table.component';
import { ComplianceAuditLogDialogComponent } from './compliance-audit-log/compliance-audit-log.component';
import { ClientDataAuditLogDialogComponent } from './client-data-audit-log/client-data-audit-log.component';
import { ServiceCenterDataAuditLogDialogComponent } from './service-center-data-audit-log/service-center-data-audit-log.component';


const COMPONENTS = [
  AuditLogDialogComponent, AuditLogTableComponent, ContactInformationDialogComponent, ApplicantHistoryDialogComponent,RenewalChangesDialogComponent, ComplianceAuditLogDialogComponent, ClientDataAuditLogDialogComponent, ServiceCenterDataAuditLogDialogComponent
];

@NgModule({
  declarations: [
    ...COMPONENTS
  ],
  imports: [
    CommonModule,
    SharedModule
  ],
  exports: [AuditLogDialogComponent, ClientDataAuditLogDialogComponent, ServiceCenterDataAuditLogDialogComponent]
})
export class AuditLoggingModule { }
